import { render, staticRenderFns } from "./ModalViewEventTraining.vue?vue&type=template&id=3db13c6f&scoped=true&"
import script from "./ModalViewEventTraining.vue?vue&type=script&lang=js&"
export * from "./ModalViewEventTraining.vue?vue&type=script&lang=js&"
import style0 from "./ModalViewEventTraining.vue?vue&type=style&index=0&id=3db13c6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db13c6f",
  null
  
)

export default component.exports